<template>
    <div class="sidenav-menu">
        <div class="nav accordion" id="accordionSidenav">
            <template v-if="appTypes.length">
                <!-- Wrapper padre: Aquí inyectamos el componente transversal recursivo -->
                <MenuItemRecursive
                    :options="options"
                    parentId="accordionSidenav"
                    :appTypes="appTypes"
                    :currentAppName="app.name"
                />
            </template>
        </div>
    </div>
</template>

<script>
import typeAppService from "../../../services/typeAppService";
import MenuItemRecursive from "./MenuItemRecursive.vue";

export default {
    components: {
        MenuItemRecursive
    },
    props: {
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            appTypes: [],
        }
    },
    async mounted() {
        try {
            const { data } = await typeAppService.index();
            this.appTypes = Array.isArray(data) ? data : [];
        } catch (error) {
            console.error("Error cargando los Application Domains: ", error);
        }
    },
    computed: {
        app() {
            if (this.appTypes && this.appTypes.length) {
                const matchedApp = this.appTypes.find(app => app.name === process.env.VUE_APP_NAME);
                return matchedApp || { name: process.env.VUE_APP_NAME };
            }
            return { name: process.env.VUE_APP_NAME };
        },
    },
};
</script>